import appPage from './appPage.json'
import csi from './csi.json'
import header from './header.json'
import helpCenter from './helpCenter.json'
import index from './index.json'
import pageNotFound from './pageNotFound.json'
import quotas from './quotas.json'

const global = {
    ...index,
    appPage,
    pageNotFound,
    header,
    helpCenter,
    quotas,
    csi,
}

export default global
